<template>
  <MainLayout>
    <Head title="Exported Spreadsheets" />

    <template v-slot:header>Exported Spreadsheets</template>

    <div class="mb-4" v-if="$canAny(['builds.read', 'spreadsheets.write'])">
      <ButtonGroup>
        <Link :href="$route('builds.index')" v-if="$can('builds.read')">
          Builds
        </Link>
        <Link :href="$route('spreadsheets.upload')" v-if="$can('spreadsheets.write')">
          <UploadIcon class="w-4 h-4 mr-1" /> Upload Spreadsheet
        </Link>
      </ButtonGroup>
    </div>

    <DataTable :pagination="spreadsheets">
      <template v-slot:header>
        <th scope="col" class="">
          File
        </th>
        <th scope="col">
          Created
        </th>
        <th scope="col">
          Updated
        </th>
        <th scope="col">
          Status
        </th>
        <th scope="col">
          Progress
        </th>
        <th scope="col">
          <span class="sr-only">Download</span>
        </th>
      </template>

      <tr v-for="spreadsheet in spreadsheets.data"
          :key="spreadsheet.id"
          :class="{ 'bg-yellow-100': spreadsheet.id == exportId }">
        <td>
          {{ spreadsheet.file }}
        </td>
        <td><FormattedDate :date="spreadsheet.created_at" /></td>
        <td><FormattedDate :date="spreadsheet.updated_at" /></td>
        <td>{{ spreadsheet.status }}</td>
        <td>
          <Progress :item="spreadsheet" v-if="spreadsheet.status == 'running' && spreadsheet.batch" />
          <Badge v-else>N/A</Badge>
        </td>
        <td>
          <a :href="spreadsheet.url"
             class="text-indigo-600 hover:text-indigo-900"
             v-if="spreadsheet.status === 'finished'">Download</a>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import PageComponent from '@/pages/page-component'
import DataTable from '@/components/data-table.vue'
import {
  UploadIcon,
} from '@heroicons/vue/outline'
import Badge from '@/components/badge'
import Progress from './index-progress.vue'
import UsesPermissions from '@/mixins/uses-permissions'
import FormattedDate from '@/components/formatted-date'

export default {
  mixins: [
    PageComponent,
    UsesPermissions,
  ],

  components: {
    DataTable,
    Link,
    Badge,
    UploadIcon,
    Progress,
    FormattedDate,
  },

  props: {
    spreadsheets: Object,
    exportId: [Number, String],
  },
}
</script>
